<template>
  <div class="upload-file">
    <el-upload
      v-if="editable && fileList.length < limit"
      class="upload-file-uploader"
      :headers="headers"
      :action="uploadFileUrl"
      :multiple="multiple"
      :limit="limit"
      :file-list="fileList"
      :show-file-list="false"
      :before-upload="handleBeforeUpload"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      :on-success="handleUploadSuccess"
    >
      <el-button size="mini" type="primary" icon="el-icon-upload2">点击上传</el-button>
      <div class="el-upload__tip" slot="tip" v-if="showTip">
        请上传
        <template v-if="fileSize">大小不超过 <b style="color:#f56c6c">{{ fileSize }}MB</b></template>
        <template v-if="fileType && fileType.length">格式为 <b style="color:#f56c6c">{{ fileType.join('/') }}</b></template>
        的文件
      </div>
    </el-upload>

    <div class="upload-file-list-tag">
      <el-tag
        v-for="(file, index) in fileList"
        :key="file.fileId || index"
        class="file-item-tag"
        :closable="editable"
        :disable-transitions="false"
        @close="handleDelete(index)"
        @click="downloadFile(file)"
        style="cursor:pointer;margin:4px 4px 0 0"
      >
        <i class="el-icon-paperclip"></i> {{ file.fileName }}
      </el-tag>
    </div>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
export default {
  name: 'FileUpload',
  props: {
    value: { type: Array, default: () => [] },
    limit: { type: Number, default: 5 },
    fileSize: { type: Number, default: 50 },
    fileType: { type: Array, default: () => [] },
    multiple: { type: Boolean, default: true },
    editable: { type: Boolean, default: true },
    isShowTip: { type: Boolean, default: true },
  },
  data() {
    return {
      number: 0,
      uploadList: [],
      fileList: [],
    }
  },
  computed: {
    headers() {
      return { Authorization: 'Bearer ' + getToken() }
    },
    uploadFileUrl() {
      return process.env.VUE_APP_BASE_API + '/common/upload'
    },
    showTip() {
      return this.isShowTip && (this.fileSize || (this.fileType && this.fileType.length))
    },
  },
  watch: {
    value: {
      handler(val) { this.fileList = val || [] },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleBeforeUpload(file) {
      if (this.fileType && this.fileType.length) {
        const ext = file.name.split('.').pop().toLowerCase()
        if (!this.fileType.map(t => t.toLowerCase()).includes(ext)) {
          this.$message.error(`文件格式不正确，请上传 ${this.fileType.join('/')} 格式文件!`)
          return false
        }
      }
      if (file.name.includes(',')) {
        this.$message.error('文件名不能包含英文逗号!')
        return false
      }
      if (this.fileSize) {
        if (file.size / 1024 / 1024 > this.fileSize) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`)
          return false
        }
      }
      if (this.fileList.find(item => item.fileName === file.name)) {
        this.$message.error('当前文件已存在，请勿重复上传!')
        return false
      }
      this.number++
      return true
    },
    handleExceed() {
      this.$message.warning(`上传文件数量不能超过 ${this.limit} 个!`)
    },
    handleUploadError() {
      this.$message.error('上传失败，请重试')
      this.number--
    },
    handleUploadSuccess(res) {
      if (res.code === 200) {
        this.uploadList.push({
          fileName: res.fileName,
          fileId: res.fileId,
          fileType: res.fileName.split('.').pop(),
        })
      } else {
        this.$message.error(res.msg || '上传失败')
        this.number--
        return
      }
      if (this.number > 0 && this.uploadList.length === this.number) {
        this.fileList = this.fileList.concat(this.uploadList)
        this.uploadList = []
        this.number = 0
        this.$emit('input', this.fileList)
      }
    },
    handleDelete(index) {
      this.fileList.splice(index, 1)
      this.$emit('input', this.fileList)
    },
    downloadFile(file) {
      this.$download.downloadFile(file.fileId)
    },
  },
}
</script>
